import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=63b419e3&scoped=true&"
import script from "./LogoIcon.vue?vue&type=script&lang=js&"
export * from "./LogoIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=63b419e3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b419e3",
  null
  
)

export default component.exports